// extracted by mini-css-extract-plugin
module.exports = {"CommentListPlaceholder":"ie_a bha_je","CommentListPlaceholder--Legacy":"ie_b bha_qh bha_vk"};